// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__K9tTp","isChecked":"CheckBox_isChecked__ynZCt","label":"CheckBox_label__Q0Qga"};